<template>
  <v-card flat max-width="680" class="mx-auto px-5 pb-5 mt-10">
    <v-window :value="step">
      <v-window-item value="signin"><Signin /></v-window-item>
      <!-- <v-window-item value="registration"><Registration /></v-window-item> -->
      <v-window-item value="recover"><RecoverPassword /></v-window-item>
    </v-window>
  </v-card>
</template>

<script>
import Signin from "./Signin";
import Registration from "./Registration";
import RecoverPassword from "./RecoverPassword";

export default {
  name: "Authentication",
  components: { Signin, Registration, RecoverPassword },
  computed: {
    step() {
      this.$store.dispatch("clearErrors");
      return this.$store.state.authentication.step;
    },
  },
};
</script>
